export default "__VITE_ASSET__XSYC2l8k__"